import React from 'react';
import { Button, Form, Container, Row, Col, OverlayTrigger, Modal, FormGroup, Card } from "react-bootstrap";
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import localeInfo from 'rc-pagination/lib/locale/en_US';
import { ENV } from '../../config/config';

const GalleryModal = ({
    isOpenModal,
    setOpenModal,
    setImage,
    gallery,
    pagination,
    onPageChange,
    reset,
    applyFilters,
    filters,
    setFilters,
    resetButton
}) => {

    return (
        <Container fluid>
            <Modal className="modal-primary custom-modal" onHide={() => setOpenModal(!isOpenModal)} show={isOpenModal}>
                <Modal.Header className="justify-content-center">
                    <Row>
                        <div className="col-12">
                            <h4 className="mb-0 mb-md-3 mt-0">
                                Gallery
                            </h4>
                        </div>
                    </Row>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={6} style={{ 'margin-top': '10px' }}>
                            <Form.Group>
                                <Form.Control value={filters.name} type="text" placeholder="Search with name..." onChange={(e) => setFilters({ ...filters, name: e.target.value })} />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group>
                                <Button className="btn-filled mr-3 mt-1" onClick={applyFilters}>Search</Button>
                                {resetButton && <Button style={{ 'margin-top': '8px' }} variant="warning" className='outline-button' onClick={reset}>Reset</Button>}
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className="card-responsive">
                        <Row>
                            {
                                gallery && gallery.length ?
                                    gallery.map((image, index) => {
                                        return (
                                            <Col md='3'>
                                                <Card key={index} className="custom-card" style={{ width: '18rem', border: 'solid' }} onClick={() => { setImage(image); setOpenModal(!isOpenModal) }}>
                                                    <Card.Img variant="top" src={ENV.assetsUrl + "gallery/" + image?.image} />
                                                    <Card.Body>
                                                        <Card.Title>{image.name}</Card.Title>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        )
                                    })
                                    :
                                    <div className="alert alert-info" role="alert">No Image Found</div>
                            }
                        </Row>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    {
                        pagination &&
                        <Pagination
                            className="m-3"
                            defaultCurrent={1}
                            pageSize // items per page
                            current={pagination.page} // current active page
                            total={pagination.pages} // total pages
                            onChange={onPageChange}
                            locale={localeInfo}
                        />
                    }
                    <Button className="outline-button" onClick={() => setOpenModal(!isOpenModal)}>Close</Button>
                </Modal.Footer>
            </Modal>
        </Container >
    )
}

export default GalleryModal;